import {buttonColors} from "../../../Pickers/InputTheme";
import {i18n} from "../../../../Utils/i18n/i18n";
import {Button} from "../../../Form/Button/Button";
import React, {useEffect} from "react";
import {Modal} from "../../../Smart/Modal/Modal";
import {CopyText} from "../../../../Utils/CopyText/CopyText";
import {SA_getPartnerAPIKey} from "../../../../Services/SA_api";
import './SuperAdminGenerateAPIKey.scss'

export const SuperAdminGenerateAPIKey = ({partnerId}) => {
    const [generateAPIKeyModalOpen, setGenerateAPIKeyModalOpen] = React.useState(false)
    const [apiKey, setApiKey] = React.useState(null)
    const onOpenModal = () => {
        setGenerateAPIKeyModalOpen(true)
    }
    const closeEditModal = () => {
        setGenerateAPIKeyModalOpen(false)
    }

    const generateAPIKey = async () => {
        const apiKey = await SA_getPartnerAPIKey({partnerId: partnerId})
        setApiKey(apiKey)
        onOpenModal()
    }

    return <div className="SuperAdminGenerateAPIKey">
        <Button color={buttonColors.GOLD}
                size="small"
                text={i18n.translate('superAdmin.generateAPIKeyModal.generateAPIKey')}
                onClick={generateAPIKey}/>

        {generateAPIKeyModalOpen ? <Modal
            open={generateAPIKeyModalOpen}
            onClose={closeEditModal}>
            <div className="SuperAdminEditFFModal modalWrapper">
                <div className="modalTitle">
                    <div>{i18n.translate('superAdmin.generateAPIKeyModal.modalTitle')}</div>
                </div>
                <div className="modalContent">
                    {apiKey ? <div className="SuperAdminTokenCopy">
                        <CopyText text={apiKey}/>
                    </div> : ""}
                </div>
                <div className="modalFooter">
                    <Button
                        color={buttonColors.GREY}
                        onClick={closeEditModal}
                        text={i18n.translate('general.close')}
                    />
                </div>
            </div>
        </Modal> : ''}
    </div>
}